import React, { Component, useContext, useState } from "react";
import { Route, NavLink, HashRouter, Redirect } from "react-router-dom";
import Navbar from "./components/navbar/Navbar";
import mercadoInternacional from "./mercadoInternacional/MercadoInternacional";
import Noticias from "./noticias/Noticias";
import Sala from "./sala/Sala";
import Chat from "./chat/Chat";
import Home from "./home/Home";
import Bodiva from "./mercadonacional/Bodiva";
import Profile from "./profile/Profile";
import SideMenu from "./components/sidebar/SideMenu";
import { AuthContext } from "../context/AuthContex";
export default function Main() {
  const [inactive, setInactive] = useState(true);
  const { user } = useContext(AuthContext);

  return (
    <div>
      <HashRouter>
        <SideMenu
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
        />
        <div className={`s-container ${inactive ? "inactive" : ""}`}>
          <Route exact path="/">
            {" "}
            <Redirect to={`/perfil/` + user._id} />{" "}
          </Route>
          <Route path="/noticias" component={Noticias} />
          <Route
            path="/mercado-internacional"
            component={mercadoInternacional}
          />
          <Route path="/sala" component={Sala} />

          {user.categoria == "Demo" ? (
            <Route path="/chat" component={Chat}>
              <Redirect to={`/perfil/` + user._id} />
            </Route>
          ) : (
            <Route path="/chat" component={Chat} />
          )}

          <Route path="/feed" component={Home}>
            {" "}
            {user.categoria != "vip" ? (
              <Redirect to={`/perfil/` + user._id} />
            ) : (
              <Route path="/feed" component={Home} />
            )}{" "}
          </Route>
          <Route path="/mercado-nacional" component={Bodiva} />
          <Route path="/perfil/:userId" component={Profile} />
        </div>
      </HashRouter>
    </div>
  );
}
